export enum SpinnerStatus {
  START,
  STOP,
}
